export default "__VITE_ASSET__CN$ImFlJ__"